/**
 * Figma `Player Card v7` — the add-players drawer's player card, in both the
 * variants the design ships.
 *
 * They are nested here because they are ONE Figma component: the default export
 * is the SUGGESTION variant (identity + reason chips + Add/Dismiss) and
 * `WatchlistPlayerCard` is the WATCHLIST variant (identity only, draggable).
 * `PlayerCardIdentity` is the row they share; housing the variants under
 * separate top-level molecules is what would let that shared header drift.
 * @module features/player-kanban/components/molecules/AddPlayersRow
 */
export { default } from "./AddPlayersRowContainer";
export { default as PlayerCardIdentity } from "./PlayerCardIdentity";
export type { PlayerCardIdentityViewProps } from "./PlayerCardIdentity";
export { default as WatchlistPlayerCard } from "./WatchlistPlayerCard";
export type { WatchlistPlayerCardContainerProps } from "./WatchlistPlayerCard";
